import { Action } from 'redux'

export interface PaymentState {
  payment: any[]
  isLoading: boolean
}

export enum PaymentActionTypes {
  GET_PAYMENT_START = '@@payment/GET_PAYMENT_START',
  GET_PAYMENT_SUCCESS = '@@payment/GET_PAYMENT_SUCCESS',
  GET_PAYMENT_ERROR = '@@payment/GET_PAYMENT_ERROR',
}

export interface PaymentAction extends Action<PaymentActionTypes> {
  payment?: PaymentState['payment']
}
